import { ExpoStand } from 'opensolar-pageeditor'
import { generateEmbedUrl, sanitizeHtml } from 'opensolar-pageeditor/src/renderer/utils'
import { styled } from 'opensolar-ui'
import { FC, useMemo } from 'react'

const Frame = styled('iframe', { name: 'Frame' })({
  width: '100%',
  height: '100%',
  border: 0,
})
const Wrapper = styled('div', { name: 'Wrapper' })({
  aspectRatio: '16 / 9',
  width: '100%',
  overflow: 'hidden',
})

const ContentWrapper = styled('div', { name: 'ContentWrapper' })({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
})

const CompanyContent: FC<ExpoStand> = ({ contents }) => {
  const ourStoryElement = useMemo(() => {
    if (contents?.elements) {
      return contents.elements.find((x) => x.contentType === 'our_story')
    }
  }, [contents])

  if (!ourStoryElement || ourStoryElement.contentType !== 'our_story' || !ourStoryElement.data) return null

  const content = ourStoryElement.data
  return (
    <ContentWrapper>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content.body) }} />
      {content.video && <VideoPlayer videoUrl={content.video} />}
    </ContentWrapper>
  )
}

const VideoPlayer = ({ videoUrl }) => {
  const videoLink = useMemo(() => generateEmbedUrl(videoUrl), [videoUrl])
  if (!videoLink) return null
  return (
    <Wrapper>
      <Frame src={videoLink} frameBorder={0} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
    </Wrapper>
  )
}

export default CompanyContent
